import { render, staticRenderFns } from "./FormPerVoucherInv.vue?vue&type=template&id=2d844e87"
import script from "./FormPerVoucherInv.vue?vue&type=script&lang=js"
export * from "./FormPerVoucherInv.vue?vue&type=script&lang=js"
import style0 from "./FormPerVoucherInv.vue?vue&type=style&index=0&id=2d844e87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports